export default class CreateSessionResultModel {
  public SessionId?: string;
  public Nonce?: string;
}
